import { Box, Chip, Typography } from "@mui/material";

export const SearchChip = ({ value, count }) => {
  return (
    <Chip
      color="info"
      label={
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" fontWeight={500}>
            {value}
          </Typography>

          <Box
            sx={{
              px: 1,
              py: "2px",
              borderRadius: "12px",
              backgroundColor: "primary.dark",
              color: "#fff",
              fontSize: "12px",
              fontWeight: 600,
              minWidth: "22px",
              textAlign: "center",
            }}
          >
            {count}
          </Box>
        </Box>
      }
    />
  );
};
